import {
  dimensiondata_1_tetelek_group_w200_dimension_1_2_3_row,
  gigawatt_ora_value_1_data_precision_no_year_summary,
  year_column,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const evesVillanyMerlegConfig: PivotGridConfig = {
  showChart: false,
  filterYear: { numberOfYears: 3 },
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/EvesVillanyMerleg',
      select: ['date', 'dimension_1', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tetelek_group_w200_dimension_1_2_3_row,
      year_column,
      gigawatt_ora_value_1_data_precision_no_year_summary,
      order_1,
      order_2
    ],
  },
};
